import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Row } from 'antd';
import SituationFormField from '../../DirectSale/SituationFormField';
import StatusTag from '@/components/_common/StatusTag';

export default function PurchaseHeader() {
  const { situation, purchase } = useReleasePurchaseFormContext();

  const origin = purchase?.boschMigration
    ? 'Bosch'
    : purchase?.proPartsComplementId
    ? 'ZF ProParts'
    : null;

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 24 }} align="middle">
      <Col>
        <SituationFormField initialValue={situation} />
      </Col>

      {!!origin && (
        <Col style={{ display: 'flex', alignItems: 'center' }}>
          <StatusTag size="lg" color="blue" label={`Origem: ${origin}`} />
        </Col>
      )}
    </Row>
  );
}
